module.exports = __webpack_public_path__ + "img/class.3a27feaa.png";